import React, { useState, useEffect, FC } from "react";
import cx from "classnames";
import { useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { Select } from "@foris/avocado-suite";
import { classroomQuery } from "../graphql/classroom.queries";
import { ISelectorReturn, IOption } from "./ISelectors";
import { ClassroomType, DataQuery } from "@models/ISchema";
import { IParams } from "@models/IParams";
import css from "./selectors.module.scss";

interface ClassRoomSelectProps extends Omit<ISelectorReturn, "label"> {
  label?: boolean;
  labelValue?: string;
  value?: IOption | null;
}

const ClassRoomSelect: FC<ClassRoomSelectProps> = ({
  onCallback,
  className,
  placeholder,
  label,
  labelValue,
  value,
}) => {
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [optionsClassroom, setOptionsClassroom] = useState([]);
  const [valueClassroom, setValueClassroom] = useState(value ?? null);

  // Hooks
  const client = useApolloClient();
  const { scenario }: IParams = useParams();

  const variablesClassRoom = {
    query: classroomQuery,
    variables: {
      scenarioId: scenario,
    },
  };

  const setClassroomOptions = async (data: any) => {
    if (data && data.data) {
      const dataQuery: DataQuery = data.data.data;
      const optCompuses = [];
      if (dataQuery.classroomTypes.items.length > 0) {
        dataQuery.classroomTypes.items.forEach((classroom: ClassroomType) => {
          optCompuses.push({
            label: `${classroom?.code ? `${classroom?.code}, ` : ""}${classroom?.name}`,
            value: classroom.id,
          });
        });
      }
      setOptionsClassroom(optCompuses);
    }
  };

  const getClassroomOptions = async () => {
    try {
      setIsLoading(true);
      const data = await client.query(variablesClassRoom);
      await setClassroomOptions(data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (optionsClassroom.length === 0) {
      getClassroomOptions();
    }
  });

  return (
    <div className={cx(css.selectors, className)}>
      <Select
        label={label ? labelValue : undefined}
        placeholder={placeholder}
        options={optionsClassroom}
        isLoading={isLoading}
        disabled={isLoading}
        isClearable
        value={valueClassroom}
        onChange={(value: IOption) => {
          if (value) {
            setValueClassroom(value);
            onCallback(value);
          } else {
            setValueClassroom(null);
            onCallback(value);
          }
        }}
      />
    </div>
  );
};

export default ClassRoomSelect;
